import { BrowserService } from './browser.service';
import {
    NEW_CLIENT_ID,
    NEW_SECRET_PROD,
    URL_PROXY_LOGIN_SCP,
    HOST_EHR, URL_NEW_LOGIN_SCP_PROD_API, URL_SNS_SEND, REDIRECT_URI,
    URL_GERENCIADOR
} from './../util/constants';
import { Platform, ToastController, LoadingController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Usuario } from '../models/usuario.model';
import { RequestService } from './request.service';
import { Router } from '@angular/router';
import { Organization } from 'src/models/organization.model';
import { Practicioner } from 'src/models/practicioner.model';
import { PracticionerRole } from 'src/models/practicionerRole.model';
import jwt_decode from 'jwt-decode';

export const USER_DATA = '_scp_user_data';
export const USER_IS_LOGGED = '_scp_user_is_logged';
export const TOKEN_AUTH = '_scp_tokenAuthorization_res';
export const USER_TERMO = '_cetas_termo';
export const TOKEN_AUTH_GOV = '_scp_tokenAuthorization_res_gov';
export const TOKEN_AUTH_GOV_INT = '_scp_tokenAuthorization_res_gov_int';

export class ScpToken {
    access_token?: string;
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticateService {
    $userData: BehaviorSubject<any> = new BehaviorSubject({});

    result: any = {};
    code = '';
    text = '';

    term = false;

    constructor(private http: RequestService,
        private platfom: Platform,
        private loadingCtrl: LoadingController,
        private browser: BrowserService,
        private toastController: ToastController,
        private router: Router) {
    }

    getHeader(clientId: string, secret: string) {
        const aut = btoa(`${clientId}:${secret}`);
        const httpOptions = {
            'Accept': '*/*',
            'Sec-Fetch-Mode': 'cors',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: 'Basic ' + aut
        };
        return httpOptions;
    }

    getTerm() {
        return this.term;
    }
    setTerm(term) {
        this.term = term;
    }

    getHeaderToken(token) {
        const httpOptions = {
            Authorization: 'Bearer ' + token
        };
        return httpOptions;
    }

    public getAuthorizationToken(): string {
        return localStorage.getItem(TOKEN_AUTH);
    }

    public clearAuthorizationToken(): void {
        localStorage.removeItem(TOKEN_AUTH);
    }

    public resetAuthorizationToken(token: string): void {
        localStorage.setItem(TOKEN_AUTH, token);
    }

    public resetAuthorizationTokenGov(token: string): void {
        localStorage.setItem(TOKEN_AUTH_GOV, token);
    }
    public getAuthorizationTokenGov(): string {
        return localStorage.getItem(TOKEN_AUTH_GOV);
    }

    public resetAuthorizationTokenGovInt(token: string): void {
        localStorage.setItem(TOKEN_AUTH_GOV_INT, token);
    }
    public getAuthorizationTokenGovInt(): string {
        return localStorage.getItem(TOKEN_AUTH_GOV_INT);
    }

    public removeData(name) {
        localStorage.removeItem(name);
    }

    public async limparStorage() {
        await localStorage.clear();
        await this.router.navigate(['/'], { replaceUrl: true }).then(nav => {
            window.location.reload();
        });
    }

    public getData(name): Usuario {
        const userData = localStorage.getItem(name);
        return JSON.parse(userData);
    }

    public setData(data: object, name): void {
        if (data) {
            const userData = JSON.stringify(data);
            localStorage.setItem(name, userData);
            this.$userData.next(data);
        }
    }

    public isLogged(): boolean {
        return !!localStorage.getItem(TOKEN_AUTH);
    }

    async setAccess() {
        await localStorage.setItem(USER_TERMO, '1');
    }

    getAccess(): boolean {
        return !!localStorage.getItem(USER_TERMO);
    }

    async errorLogin() {
        const toast = await this.toastController.create({
            cssClass: 'modal-toast',
            message: 'Ocorreu um erro ao acessar, tente novamente mais tarde.',
            position: 'top',
            duration: 2000
        });
        await toast.present();
        this.router.navigateByUrl('/login');
        document.location.replace('');
    }

    async exceptionMsg(msg, duration = 2000) {
        const toast = await this.toastController.create({
            cssClass: 'modal-toast',
            message: msg,
            position: 'top',
            duration: duration,
        });
        await toast.present();
    }

    async exceptionMsgCenter(msg, duration = 2000) {
        const toast = await this.toastController.create({
            cssClass: 'modal-toast',
            message: msg,
            position: 'middle',
            showCloseButton: true,
            closeButtonText: "Fechar",
            duration: duration
        });
        await toast.present();
    }


    async firstAccess() {
        if (this.getAccess()) {
            this.router.navigateByUrl('/home/list');
        }
    }

    async checklogin() {
        if (!this.isLogged()) {
            //this.router.navigateByUrl('/login');
        }
    }

    async login(auth?, token?) {
        if (!token) {
            await this.browser.newOpenLogin();
            //let token = await this.gerarContexto(auth);
            //this.goToPacient(auth, token);
        } else {
            this.goToPacient(auth, token);
        }
    }

    async getContext(cnsPaciente) {
        let cnes: any = await this.getData('_organization_context');
        let prof: any = await this.getData('_pratictioner_context');
        let token = await this.gerarContexto({
            cnes: cnes.id,
            cnsProfissional: prof.id,
            cnsPaciente: cnsPaciente
        });

        if (token.messages) {
            this.exceptionMsg(token.messages[0], 4000);
        } else {
            await this.resetAuthorizationToken(token);
            if (cnsPaciente == 706806789659826 || cnsPaciente == 708102543090435/*cnsPaciente == 705206408620071 || cnsPaciente == 707401022340970 */) {
                //this.sendPush(cnsPaciente);
            }
            this.router.navigateByUrl('/home/pacient');
        }
    }

    async goToPacient(auth, token) {
        let loading = await this.loadingCtrl.create({});
        await loading.present();
        if (token) {
            await this.resetAuthorizationToken(token);
            await this.getOrganization(auth);
            await this.getPractitioner(auth);
            await this.getPractitionerRole(auth);
            await this.getPractitionerRoles(auth);
            this.router.navigateByUrl('/home/pacient');
            await loading.dismiss();
        } else {
            await loading.dismiss();
            this.exceptionMsg('CNES não tem permissão de acesso.')
        }
    }

    async loginProxy(user: any) {
        try {
            const URL = `${URL_PROXY_LOGIN_SCP}/token/gerar?code=${user.code}&url=${REDIRECT_URI}`;
            return await this.http.get(URL, {}, this.getHeader(NEW_CLIENT_ID, NEW_SECRET_PROD));
        } catch (e) {
            return false;
        }
    }

    async loginGov(redirect = '/tabs/home') {
        const loading = await this.loadingCtrl.create({});
        await loading.present();
        this.result = await this.browser.newOpenLogin();
        if (this.result && this.result.code) {
            const login = await this.getTokenWithNewCode(this.result);
            if (login === true) {
                await loading.dismiss();
                this.router.navigate([redirect]);
            } else {
                await loading.dismiss();
                await this.errorLogin();
            }
        } else {
            await loading.dismiss();
            await this.errorLogin();
        }
    }

    async loginWithToken(params, loading) {
        if (params && params.code) {
            const login = await this.getTokenWithNewCode(params);
            if (login) {

                let context = null;
                let getInfo: any = await this.getInfoUser(login);
                let user = this.getUserData();
                let prof = null;


                [context, prof] = await Promise.all(
                    [this.getIntegrationContext(),
                    this.getPractitioner({ cnsProfissional: user.cns })]
                )
                /*if (cnsProfissional != user.cns) {
                    loading.dismiss();
                    await this.exceptionMsg('CNS do profissional é diferente do utilizado no login!');
                    return;
                }*/
                if (prof) {
                    loading.dismiss();
                    localStorage.setItem('auth', '1');
                    this.router.navigateByUrl('/home/pacient');
                } else {
                    loading.dismiss();
                    await this.errorLogin();
                }
            } else {
                loading.dismiss();
                await this.errorLogin();
            }
        }
    }

    public getUserData(): Usuario {
        const userData = localStorage.getItem(USER_DATA);
        return new Usuario(JSON.parse(userData));
    }

    public setUserData(data: object): void {
        if (data) {
            const userData = JSON.stringify(data);
            localStorage.setItem(USER_DATA, userData);
            this.$userData.next(data);
        }
    }

    async getInfoUser(access_token) {
        const httpOptions = {
            Authorization: access_token
        };
        let decode: any = await this.getDecodeTokenGov()
        console.log('decode==', decode)
        return await this.http.get(HOST_EHR + '/api/fhir/r4/Practitioner?identifier=' +
            encodeURI('http://rnds.saude.gov.br/fhir/r4/NamingSystem/cpf|' + decode.sub), null, this.getHeadersContext({})).then(usuario => {

                console.log('pratictioner', usuario)
                if (usuario.entry && usuario.entry[0] && usuario.entry[0].resource) {
                    let pratictioner = new Practicioner(usuario.entry[0].resource);
                    if (pratictioner) {
                        const user = new Usuario({ ...pratictioner, cpf: decode.sub, cns: pratictioner.id });
                        this.setUserData(user.toDTO());
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            }, (error) => {
                return false;
            });
    }

    async getTokenWithNewCode(data: object) {
        const scpToken = await this.loginProxy(data);
        if (scpToken) {
            //if (await this.verificaConfiabilidade(scpToken.access_token)) {
            if (scpToken.access_token) {
                await this.resetAuthorizationTokenGov(scpToken.access_token);
                await this.resetAuthorizationTokenGovInt(scpToken.access_token);
                await this.getTokenProsus();
                return scpToken.access_token;
            } else {
                return false;
            }
            // } else {
            //   return false;
            //}
        }
    }

    async verificaConfiabilidade(token: any) {
        let decode: any = await jwt_decode(token);
        console.log(decode);
        const URL = `${URL_NEW_LOGIN_SCP_PROD_API}/confiabilidades/v2/contas/${decode.sub}/confiabilidades`;
        const selos = await this.http.get(URL, {}, this.getHeaderToken(token));
        if (selos) {
            let valid = false;
            selos.forEach(item => {
                if (item.confiabilidade.id === 'biovalid_facial') {
                    valid = true;
                }
            });
            if (valid === false) {
                this.router.navigateByUrl('/login-facial');
                document.location.replace('/login-facial');
            }
            return valid;
        }
        return false;
    }

    async sendLoginFacial() {
        this.router.navigateByUrl('/login-facial');
        document.location.replace('/login-facial');
    }

    async gerarContexto(params) {
        let user = await this.getUserData()
        return await this.http.postDirectText(HOST_EHR + '/api/contexto-atendimento',
            {
                cnes: params.cnes,
                cnsProfissional: user.cns,
                cnsPaciente: params.cnsPaciente
            }, this.getHeadersContext(params), true).then(data => {
                return data;
            }).catch((error) => {
                if (error.error) {
                    return JSON.parse(error.error);
                } else {
                    return null;
                }
            });
    }

    async sendPush(cns) {
        //let user = await this.getUserData()
        return await this.http.postDirectText(URL_SNS_SEND + '/api/authenticate',
            {
                username: 'ehr_app_auth',
                password: 'MBA_AKEGtMiMQXYB_EHR'
            }, {}, true).then(data => {
                let item = JSON.parse(data);
                this.sendPushSNS(cns, item.token)
            }).catch((error) => {
                if (error.error) {
                    return JSON.parse(error.error);
                } else {
                    return null;
                }
            });
    }

    async sendPushSNS(cns, token) {
        let user = await this.getUserData()
        const httpOptions = {
            'x-access-token': token,
            'Content-Type': 'application/json',
        };
        return await this.http.postDirectText(URL_SNS_SEND + '/api/push/cns',
            {
                cns: cns,
                msg: `Seus dados foram acessados pelo ${user.nome} em Unidade Mista`
            }, httpOptions, true).then(data => {
            }).catch((error) => {
                if (error.error) {
                    return JSON.parse(error.error);
                } else {
                    return null;
                }
            });
    }

    async getPractitioner(params) {
        return await this.http.get(HOST_EHR + '/api/fhir/r4/Practitioner/' + params.cnsProfissional,
            {
                cns: params.cnsProfissional,
            }, this.getHeadersContext(params)).then(data => {
                let pratictioner = new Practicioner(data);
                this.setData(new Practicioner(data), '_pratictioner_context');
                return pratictioner;
            }).catch((error) => {
                if (error.error.issue && error.error.issue[0] && error.error.issue[0].diagnostics.includes('(EHR-ERR835)')) {
                    this.router.navigateByUrl('/login-facial');
                    document.location.replace('/login-facial');
                } else {
                    return null;
                }
            });
    }

    async getOrganization(params) {
        return await this.http.get(HOST_EHR + '/api/fhir/r4/Organization/' + params.cnes,
            {
                cnes: params.cnes
            }, this.getHeadersContext(params)).then(data => {
                this.setData(new Organization(data), '_organization_context');
            }).catch((error) => {
                return null;
            });
    }

    async getOrganizationReference(params) {
        return await this.http.get(HOST_EHR + '/api/fhir/r4/' + params.cnes,
            null, this.getHeadersContext(params)).then(data => {
                let org = new Organization(data);
                return org;
            }).catch((error) => {
                return null;
            });
    }

    async getListCnes() {
        let list: any = await this.getData('_role_cnes_context');
        return list;
    }

    async getPractitionerRole(params) {
        return await this.http.get(HOST_EHR + '/api/fhir/r4/PractitionerRole/' + params.cnsProfissional + '-' + params.cnes,
            {
                id: params.cnsProfissional + '-' + params.cnes
            }, this.getHeadersContext(params)).then(data => {
                this.setData(new PracticionerRole(data), '_role_context');
            }).catch((error) => {
                return null;
            });
    }

    async getPractitionerRoles(params) {
        return await this.http.get(HOST_EHR + '/api/fhir/r4/PractitionerRole' +
            '?practitioner.identifier=' + encodeURI('http://rnds.saude.gov.br/fhir/r4/NamingSystem/cns|' + params.cnsProfissional),
            null, this.getHeadersContext(params)).then(data => {
                let result = [];
                if (data.entry) {
                    data.entry.forEach(element => {
                        console.log(result.find((data) => { return data.role == element.resource.id }))
                        if (!result.find((data) => { return data.role == element.resource.id })) {
                            result.push({
                                role: element.resource.id,
                                cnes: element.resource.organization.reference,
                                cbo: element.resource.code[0].coding[0].display,
                                cbo_id: element.resource.code[0].coding[0].code,
                            });
                        }
                    });
                }
                this.setData(result, '_role_cnes_context');
                return result;
            }).catch((error) => {
                return null;
            });
    }


    async getDecodeToken() {
        try {
            return await jwt_decode(await this.getAuthorizationToken());
        } catch (e) {
            this.exceptionMsg('Contexto inválido.');
        }
    }

    async getDecodeTokenGov() {
        try {
            return await jwt_decode(await this.getAuthorizationTokenGov());
        } catch (e) {
            this.exceptionMsg('Contexto inválido.');
        }
    }

    getHeadersContext(params) {
        let server = JSON.parse(localStorage.getItem('app_icp_token'));
        let token = this.getAuthorizationTokenGov();
        if (!token) {
            token = this.getAuthorizationToken()
        }
        const httpOptions = {
            //'X-Authorization-Origin': 'CNES',
            'X-Authorization-Server': 'Bearer ' + server.access_token,
            //'X-Authorization-Audience': 'prosus.saude.gov.br',
            //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
            'Authorization': 'Bearer ' + token,
            //'Authorization': params.cnsProfissional,
            'Content-Type': 'application/json',
        };
        return httpOptions;
    }


    getHeadersContextAuth(params) {
        let server = JSON.parse(localStorage.getItem('app_icp_token'));
        const httpOptions = {
            //'X-Authorization-Origin': 'CNES',
            'X-Authorization-Server': 'Bearer ' + server.access_token,
            //'X-Authorization-Audience': 'prosus.saude.gov.br',
            //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
            'Authorization': 'Bearer ' + this.getAuthorizationTokenGov(),
            //'Authorization': params.cnsProfissional,
            'Content-Type': 'application/json',
        };
        return httpOptions;
    }

    async getTokenProsus() {

        const loading = await this.loadingCtrl.create({});
        await loading.present();
        return await this.http.get(`${URL_GERENCIADOR}v1/rnds/token/profissional`,
            {}, {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.getAuthorizationTokenGov(),
        }).then(data => {
            console.log(data);
            localStorage.setItem('app_icp_token', JSON.stringify(data));
            loading.dismiss();
        }).catch((error) => {
            loading.dismiss();
            return null;
        });
    }

    async getIntegrationContext() {
        let contexto = localStorage.getItem('originContext');
        let token = await this.http.postDirectText(HOST_EHR + '/api/autenticar-contexto',
            contexto
            , this.getHeadersContextText()).then(data => {
                return data;
            }).catch((error) => {
                if (error.error) {
                    return JSON.parse(error.error);
                } else {
                    return null;
                }
            });

        if (token.messages) {
            this.exceptionMsgCenter(token.messages[0], 0);
        } else {
            await this.resetAuthorizationToken(token);
            // await this.resetAuthorizationTokenGovInt(token);
            // setTimeout(() => {
            //     this.router.navigateByUrl('/home/pacient');
            // }, 1000);
        }
    }

    getHeadersContextText() {
        let server = JSON.parse(localStorage.getItem('app_icp_token'));
        const httpOptions = {
            'Content-Type': 'text/plain',
            //'X-Authorization-Origin': ORIGIN,
            //'X-Authorization-Audience': 'prosus.saude.gov.br',
            //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
            'X-Authorization-Server': 'Bearer ' + server.access_token,
            'Authorization': 'Bearer ' + this.getAuthorizationTokenGovInt(),
        };

        return httpOptions;
    }


    async verifyTokenValido() {
        const token = this.getAuthorizationToken();
        const user = await this.getInfoUser(token);
        if (user === false) {
            return false;
        } else {
            return true;
        }
    }
}
